import { MolhamListTargetable } from "apiTypes";
import useCustomSWR from "customHooks/useCustomSWR";
import { arrayFromNum } from "utils/arrayFromNum";
import { usePreferenceContext } from "../../../context/PreferencesContext";
import useDonationSectionsMeta from "../../../customHooks/useDonationSectionsMeta";
import CustomContentLoader from "../CustomContentLoader";
import NoData from "../NoData";
import OtherOption from "./OtherOption";

const OtherOptionsSidebar = () => {
  const { selectedSectionObject } = useDonationSectionsMeta();
  const { data, error, changeLocaleLoading } = useCustomSWR<{
    data: MolhamListTargetable[];
  }>(selectedSectionObject?.page_api_endpoint_path);
  const { curr } = usePreferenceContext();

  if (error) {
    return <NoData />;
  }

  if ((!error && !data) || changeLocaleLoading) {
    return (
      <div>
        {arrayFromNum(8).map((skeleton) => (
          <CustomContentLoader key={skeleton} viewBox="0 0 400 125">
            <rect x="15" y="14" rx="10" ry="10" width="98" height="102" />
            <rect x="128" y="16" rx="8" ry="8" width="259" height="52" />
            <rect x="127" y="85" rx="8" ry="8" width="224" height="29" />
          </CustomContentLoader>
        ))}
      </div>
    );
  }

  return (
    <div className="widget mt-2 mb-5">
      {data?.data?.slice(0, 8).map((target) => {
        return (
          <OtherOption
            target={target}
            key={target.id}
            routeUrl={selectedSectionObject?.page_path}
            curr={curr}
          />
        );
      })}
    </div>
  );
};

export default OtherOptionsSidebar;
